import React, { useEffect, useCallback, useState} from 'react';
import {getParameterName} from 'utils/getParameterName.js';
import {connect} from 'react-redux';
import EffectParameterSlider from './EffectParameterSlider.js';

const PaletteDetails = ({effect, palette}) => { 
    let parameters = effect.track.getAllParameters()
        .filter(
            parameter => palette in parameter.paletteToValue);

    return (
        <div className="palette-details">
        {parameters.map(
            x => <EffectParameterSlider
                   key={x.id}
                   name={getParameterName(x)}
                   min={x.min}
                   max={x.max}
                   sequencerEngine={effect.track.sequencerEngine}
                   step={0.01}
                   isParameter={true}
                   parameter={x}
                 />)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaletteDetails);
